import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CellWifiIcon(props: IconProps) {
    return <Icon {...props} iconKey={"cell_wifi"}/>
}
